import React, { memo } from "react";
import Modal from "react-bootstrap/Modal";

import useShowModalContext from "../Hooks/ContextHooks/General/useShowModalContext"

const ModalComponent = ({ show, handleClose, children, title, size }) => {
  const { showModal, setShowModal } = useShowModalContext()
  const handleCloseModal = () => {
      setShowModal(false)
  }
  return (
    <Modal size={size} show={showModal ? showModal : show} onHide={showModal ? handleCloseModal : handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">{title && title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Save Changes
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default memo(ModalComponent);